import { Button, Stack } from "@mui/material";
import { forwardRef } from "react";
import Modal, { CommonModalProps } from "..";
import { DbOrderManualTaskTemplateInfos } from "../../../Core/Api/Types/db-order-manual-task-template-infos";
import ConfigManualTaskFormRender from "../../Config/ConfigManualTask/ConfigManualTaskForm/config-manual-task-form-render";
import { useTranslation } from "react-i18next";

export type ModalManualTaskTemplateElementProps = {
  tpl: DbOrderManualTaskTemplateInfos;
};

export type ModalManualTaskTemplateProps = CommonModalProps<ModalManualTaskTemplateElementProps>;

const ModalManualTaskTemplate = forwardRef<any, ModalManualTaskTemplateProps>((props, ref) => {
  const { t } = useTranslation();
  const { tpl, closeModal, ...modalProps } = props;

  return (
    <Modal
      title={t("modal:title.manualTaskTemplate", { description: tpl.description })}
      reference={ref}
      closeModal={closeModal}
      width={800}
      footer={
        <Stack direction="row" justifyContent="space-between">
          <Button variant="outlined" onClick={closeModal}>
            {t("common:close")}
          </Button>
        </Stack>
      }
    >
      <ConfigManualTaskFormRender tpl={tpl} />
    </Modal>
  );
});

export default ModalManualTaskTemplate;
